import { lazy, Suspense, useContext, useMemo } from 'react';
import { ConcernsContext } from '../../lib/context/ConcernsContext';
import { ConcernType } from '../concerns/Concern';

const Concerns = lazy(() => import('../concerns/Concerns'));

type AccountIssuesProps = {
  wrapper: (children: React.ReactNode) => React.ReactNode;
};

const limitedTypes: ConcernType[] = ['account'] as const;

const AccountIssues = ({ wrapper }: AccountIssuesProps) => {
  const { state: concernsState } = useContext(ConcernsContext);

  const accountConcerns = useMemo(
    () => concernsState.Concerns?.filter((x) => limitedTypes.includes(x.Type)).length || 0,
    [concernsState.Concerns]
  );

  if (accountConcerns === 0) {
    return null;
  }

  return wrapper(
    <Suspense>
      <Concerns displayType="widget" limit={limitedTypes} />
    </Suspense>
  );
};

export default AccountIssues;
